import gql from 'graphql-tag';

/**
 * Data of the block project-service-report-verification ("Service: Prüfung"): the service
 * verification state. Read through `Project.blocks.serviceReportVerification`, which checks the
 * block's read permission.
 */
export const PROJECT_SERVICE_REPORT_VERIFICATION_FIELDS = gql`
  fragment projectServiceReportVerificationFields on ProjectServiceReportVerificationBlock {
    id
    number
    serviceVerificationState
  }
`;
